import { createSlice } from "@reduxjs/toolkit";
import { fetchAllAvaiableTraineesForApproval, submitTraineeStatus } from "../thunks/trainingThunks/thunk";

const initialState = {
    loading: false,
    error: null,
    data: {
        trainees: [],
        trainingType: '',
        trainesSubmited: false,
        batchApproved: false,
        batchReason:'',
        submittedBy:[]
    }
};

const traineeApprovalSlice = createSlice({
    name: "traineeApproval",
    initialState,
    reducers: {
        updateTraineeStatus: (state, action) => {
            const { empId, allowed, reason = null } = action.payload;
            console.log("updateTraineeStatus", empId, allowed, reason);
            const trainee = state.data.trainees.find(t => Number(t.empId) === empId);
            if (trainee) {
                trainee.allowed = allowed === true;
                trainee.reason = allowed === false ? reason : null;
            }
        },
        updateBatchStatus:(state,action) => {
            const { batchId, status, reason = null } = action.payload;
            state.data.batchApproved=status;
            state.data.batchReason=reason;
        }
    },
    extraReducers: (builder) => {
        builder
            // Fetch trainees
            .addCase(fetchAllAvaiableTraineesForApproval.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAllAvaiableTraineesForApproval.fulfilled, (state, action) => {
                console.log("fetchAllAvaiableTraineesForApproval.fulfilled", action.payload)

                state.loading = false;
                state.data.trainees = action.payload.data.resultPayload;
                state.data.trainingType = action.payload.trainingType;
                state.data.hasSubmittedTraineeOnce = action.payload.data.hasSubmittedTraineeOnce;
                state.data.submittedBy = action.payload.data.submittedBy;
            })
            .addCase(fetchAllAvaiableTraineesForApproval.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Failed to fetch trainees";
            })
            
            // Submit trainee statuses
            .addCase(submitTraineeStatus.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.data.trainesSubmited = false;
            })
            .addCase(submitTraineeStatus.fulfilled, (state, action) => {
                state.loading = false;
                state.data.trainesSubmited = true;
                state.data.batchApproved = action.payload?.batchApproved || false;
            })
            .addCase(submitTraineeStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Failed to submit trainee statuses";
                state.data.trainesSubmited = false;
            });
    }
});

export const { updateTraineeStatus ,updateBatchStatus} = traineeApprovalSlice.actions;
export default traineeApprovalSlice.reducer;
